module.exports = __webpack_public_path__ + "static/img/pay-icon06.07e8223e.svg";